<template>
  <div class="buyer-show" v-if="noticeList.length">
    <van-notice-bar :scrollable="false" wrapable>
      <van-swipe
        vertical
        class="notice-swipe"
        :autoplay="3000"
        :show-indicators="false"
      >
        <van-swipe-item v-for="item in noticeList" :key="item.context">{{
          item.context
        }}</van-swipe-item>
      </van-swipe>
    </van-notice-bar>
  </div>
</template>

<script>
import { NoticeBar } from 'vant'
import { noticeScrollTemplate } from '@/api/activity'
export default {
  name: 'notive',
  components: {
    vanNoticeBar: NoticeBar,
  },
  data() {
    return {
      noticeList: [],
    }
  },
  mounted() {
    this.getNotice()
  },
  methods: {
    async getNotice() {
      let res = await noticeScrollTemplate(2)
      if (!res.code) {
        this.noticeList = res.data
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .van-notice-bar {
  background: transparent;
  .van-swipe-item {
    text-align: center;
    overflow: hidden;
    font-size: 12px;
  }
}
.buyer-show {
  margin: 0px auto 12px;
  .notice-swipe {
    height: 18px;
    font-size: 13px;
    font-weight: 500;
    color: #d4b37d;
    // color: #51b4ff;
    line-height: 18px;
  }
}
</style>